import { useState } from 'react';
import { useConfigStore } from '@/store/config-store';
import { useBorneStore } from '@/store/borne-store';

export function SetupScreen() {
  const setConfig = useConfigStore((s) => s.setConfig);
  const navigate = useBorneStore((s) => s.navigate);

  const [borneId, setBorneId] = useState('');
  const [borneName, setBorneName] = useState('');
  const [adminPin, setAdminPin] = useState('');

  const canSave = borneId.trim() !== '';

  function handleSave() {
    setConfig({ borneId, borneName, adminPin });
    navigate('screensaver');
  }

  return (
    <div className="h-full w-full flex items-center justify-center bg-surface p-4">
      <div className="bg-surface-card rounded-2xl p-8 w-full max-w-lg space-y-6 shadow-2xl">
        {/* Title */}
        <h1 className="text-2xl font-bold text-white text-center">
          Configuration de la Borne
        </h1>

        {/* Borne ID */}
        <div className="space-y-1">
          <label className="text-sm text-gray-400">ID de la Borne</label>
          <input
            type="text"
            value={borneId}
            onChange={(e) => setBorneId(e.target.value)}
            placeholder="BORNE_001"
            className="w-full bg-surface border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-accent"
          />
        </div>

        {/* Borne Name */}
        <div className="space-y-1">
          <label className="text-sm text-gray-400">Nom de la Borne</label>
          <input
            type="text"
            value={borneName}
            onChange={(e) => setBorneName(e.target.value)}
            placeholder="Borne Entree 1"
            className="w-full bg-surface border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-accent"
          />
        </div>

        {/* Admin PIN */}
        <div className="space-y-1">
          <label className="text-sm text-gray-400">PIN Administrateur</label>
          <input
            type="password"
            value={adminPin}
            onChange={(e) => setAdminPin(e.target.value)}
            placeholder="1234"
            className="w-full bg-surface border border-gray-700 rounded-xl px-4 py-3 text-white placeholder-gray-600 focus:outline-none focus:border-accent"
          />
        </div>

        {/* Actions */}
        <div className="flex gap-4">
          <button
            type="button"
            onClick={handleSave}
            disabled={!canSave}
            className="flex-1 btn-primary disabled:opacity-40 disabled:cursor-not-allowed"
          >
            Enregistrer
          </button>
        </div>
      </div>
    </div>
  );
}
